import { AlignLeft, FileText } from "lucide-react";
import type { SourceType } from "@/hooks/use-sources";

type DisplayType = "document" | "text";

/**
 * Collapse the wire-level source type to the two display categories the UI
 * actually distinguishes: a file (`document`) or pasted text (everything else —
 * meeting/transcript/email/slack/survey/paste, which all originate as text bodies).
 * Branch on this, not on raw `source.type`. Export if a non-icon consumer ever needs it.
 */
function displayTypeFor(type: SourceType): DisplayType {
  return type === "document" ? "document" : "text";
}

const ICONS: Record<DisplayType, typeof FileText> = {
  document: FileText,
  text: AlignLeft,
};

const LABELS: Record<DisplayType, string> = {
  document: "Document",
  text: "Pasted text",
};

export function SourceIcon({ type, className = "" }: { type: SourceType; className?: string }) {
  const Icon = ICONS[displayTypeFor(type)];
  return (
    <span
      className={`inline-flex h-8 w-8 items-center justify-center rounded-md bg-muted text-foreground/70 ${className}`}
      aria-hidden
    >
      <Icon className="h-4 w-4" />
    </span>
  );
}

export function sourceTypeLabel(type: SourceType): string {
  return LABELS[displayTypeFor(type)];
}
